
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import React, { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { FloatLabel } from 'primereact/floatlabel';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddTypeMasterDialog = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [typeName, setTypeName] = useState('');
    const [typeNameErrText, setTypeNameErrText] = useState('');
    const [typeNameErr, setTypeNameErr] = useState(false);

    const submitButtonRef = useRef(null);
    const typeNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props.ID) {
            setTypeName(props?.masterData?.TypeName);
        }

        // Delay focus to wait until dialog is fully mounted
        setTimeout(() => {
            typeNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props.ID) {
            setTypeName(props?.masterData?.TypeName);
        }

    }, []);

    const onCancel = () => {
        props.onCancel();
        setTypeName('');
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(typeName)) {
            formIsValid = false;
            setTypeNameErr(true);
            setTypeNameErrText("Type Name is required");
        } else {
            setTypeNameErr(false);
            setTypeNameErrText("");
        }
        return formIsValid;
    };

    const AddTypeMaster = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                let data = {
                    id: props.ID,
                    TypeName: typeName.trim().replace(/\s+/g, ' '),
                    CreatedBy: securityUserID,
                };

                await api
                    .post(APIConstant.path.AddUpdateTypeMaster, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        if (type === 'TypeName') {
            setTypeName(value);
        }
    };

    return (
        <div>
            <div className='p-grid'>
                <div className="p-col-12 p-md-12 p-pt-2">
                    <label htmlFor="clasName">Type Name<span style={{ color: "red" }}>*</span></label>
                    <div className="custom-inputs">
                        <FloatLabel>
                            <InputText
                                ref={typeNameRef}
                                className="p-mt-2 p-pl-2 p-w-100"
                                id="typeName"
                                type="text"
                                maxLength={100}
                                placeholder="Type Name"
                                value={typeName}
                                onChange={(e) => handleChange(e, 'TypeName')}
                                onKeyDown={(e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (submitButtonRef.current) {
                                            submitButtonRef.current.focus();
                                        }
                                    }
                                }}
                                style={{
                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                }}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {typeNameErr ? typeNameErrText : null}
                        </span>
                    </div>
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
                <Button className='btn-text-action-secondary' onClick={(e) => onCancel()}> cancel </Button>
                <Button ref={submitButtonRef} className='btn-text-action-primary submit-focus' label="Save" severity="secondary" raised onClick={(e) => AddTypeMaster()} />
            </div>
        </div>
    );
};

export default AddTypeMasterDialog;
